import React, { useEffect } from "react";
import { Buffer } from "buffer";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { LOGIN_PAGE_URL } from "../../utils/urlConstants";
import { FetalSexConfettiLayer } from "../shared/FetalSexResultBlock/FetalSexConfettiLayer";
import { FetalSexResultBlock } from "../shared/FetalSexResultBlock/FetalSexResultBlock";
import {
  getFetalSexResultBlockValue,
  isTwinStandaloneFetalSex,
  parseExternalFetalSexEmailValue,
} from "../shared/FetalSexResultBlock/fetalSexResultUtils";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  ExternalRevealClosing,
  ExternalRevealResultContent,
  ExternalRevealResultWrapper,
} from "./ExternalForwardFetalSex.styles";

export const ExternalFetalSexReveal: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { base64PatientName, base64FetalSex } = useParams<{
    base64PatientName: string;
    base64FetalSex: string;
  }>();

  const decode = (str: string): string =>
    Buffer.from(str, "base64").toString("utf8");

  const friendName = decode(base64PatientName);
  const standaloneFetalSex = parseExternalFetalSexEmailValue(
    decode(base64FetalSex),
  );
  const fetalSexResultBlockValue =
    getFetalSexResultBlockValue(standaloneFetalSex);

  useEffect(() => {
    if (!fetalSexResultBlockValue) {
      history.push(LOGIN_PAGE_URL);
    }
  }, [fetalSexResultBlockValue, history]);

  if (!fetalSexResultBlockValue) {
    return null;
  }

  const twins = isTwinStandaloneFetalSex(fetalSexResultBlockValue);

  return (
    <>
      <ExternalRevealResultWrapper>
        <FetalSexConfettiLayer />
        <ExternalRevealResultContent>
          <FetalSexResultBlock
            fetalSex={fetalSexResultBlockValue}
            leadInText={t(
              twins
                ? "fetalSex.external.friendHavingTwins"
                : "fetalSex.external.friendHavingSingle",
              { name: friendName },
            )}
          />
        </ExternalRevealResultContent>
      </ExternalRevealResultWrapper>
      <ExternalRevealClosing>
        {GetTypographyContent({
          content: t("fetalSex.external.checkBeforeSharing", {
            name: friendName,
          }),
          size: "large",
          textColor: "greyMedium",
          isBold: true,
        })}
      </ExternalRevealClosing>
    </>
  );
};
